import { SectionType } from '@/types/templateRules';

export const DEFAULT_SECTION_TYPES: SectionType[] = [
  {
    id: 'intro',
    name: 'Introduction',
    description: 'Opening paragraph or hook that captures attention',
    html_example: `<div class="intro">
  <h2></h2>
  <p></p>
</div>`,
    section_notes: 'For each intro, use a different approach: a metaphor, a joke, a question, a surprising fact, or a poetic line. Never repeat the same style twice in a row.'
  },
  {
    id: 'steps',
    name: 'Steps',
    description: 'Ordered or bulleted list for how-to content',
    html_example: `<div class="steps">
  <ol>
    <li><h3></h3><p></p></li>
    <li><h3></h3><p></p></li>
    <li><h3></h3><p></p></li>
  </ol>
</div>`,
    section_notes: 'Randomise the number of steps, the order, and the style of instructions. Sometimes use humour, sometimes be ultra-concise, sometimes add a wild analogy.'
  },
  {
    id: 'faq',
    name: 'FAQ',
    description: 'Question and answer format',
    html_example: `<div class="faq">
  <div class="faq-item"><h3></h3><p></p></div>
  <div class="faq-item"><h3></h3><p></p></div>
</div>`,
    section_notes: 'Make each Q&A unique: use rhetorical questions, silly questions, deep philosophical ones, or even a riddle. Answers can be factual, playful, or even a single word.'
  },
  {
    id: 'quote',
    name: 'Quote',
    description: 'Highlighted quote or testimonial',
    html_example: `<div class="quote">
  <blockquote><p>Only include real, relevant quotes that add value to the content. Do not create fake or generic quotes.</p><footer><cite>Real Source Name</cite></footer></blockquote>
</div>`,
    section_notes: 'Only use real, relevant quotes that add genuine value to the content. Do not create fake quotes, testimonials, or generic statements. If no appropriate quote exists, skip this section entirely.'
  },
  {
    id: 'image',
    name: 'Image',
    description: 'Static image section',
    html_example: `<div class="image">
  <figure><img src="[REAL_IMAGE_URL]" alt="Descriptive alt text for accessibility" /><figcaption>Only include if you have a real, relevant image to reference</figcaption></figure>
</div>`,
    section_notes: 'Only include image sections if you have access to real, relevant images. Do not create placeholder images or reference non-existent images. If no appropriate image is available, skip this section entirely.'
  },
  {
    id: 'feature_list',
    name: 'Feature List',
    description: 'Bullet list of product/service features',
    html_example: `<div class="feature-list">
  <ul>
    <li><h3></h3><p></p></li>
    <li><h3></h3><p></p></li>
    <li><h3></h3><p></p></li>
  </ul>
</div>`,
    section_notes: 'List features in random order, sometimes exaggerate, sometimes understate. Use unexpected adjectives or comparisons.'
  },
  {
    id: 'callout',
    name: 'Callout',
    description: 'Highlighted box or attention block',
    html_example: `<div class="callout">
  <div class="callout-content"><h3></h3><p></p></div>
</div>`,
    section_notes: 'Callouts can be warnings, encouragements, or wild ideas. Vary the format: a poem, a single word, a list, or a question.'
  },
  {
    id: 'testimonial',
    name: 'Testimonial',
    description: 'Quote with attribution',
    html_example: `<div class="testimonial">
  <blockquote><p>Only include real testimonials from actual customers or users. Do not create fake testimonials.</p><footer><cite><strong>Real Customer Name</strong><span>Real Company or Role</span></cite></footer></blockquote>
</div>`,
    section_notes: 'Only use real testimonials from actual customers, users, or stakeholders. Do not invent fake testimonials, personas, or quotes. If no genuine testimonial is available, skip this section entirely.'
  },
  {
    id: 'cta',
    name: 'Call to Action',
    description: 'Call-to-action section with button',
    html_example: `<div class="cta">
  <h2></h2>
  <p></p>
  <a href="#" class="cta-button"></a>
</div>`,
    section_notes: 'Change the CTA style every time: direct, mysterious, poetic, or humorous. The button text should never repeat.'
  },
  {
    id: 'text',
    name: 'Text',
    description: 'Generic paragraph text section',
    html_example: `<div class="text">
  <p></p>
  <p></p>
  <p></p>
</div>`,
    section_notes: 'Each paragraph should use a different style: narrative, expository, dialogue, or even a list. Randomise sentence length and structure.'
  }
];

export const getDefaultSectionRules = async () => {
  // This function would typically fetch from the database
  // For now, we'll return the default section types
  return DEFAULT_SECTION_TYPES;
}; 